import { render } from "./mode.vue?vue&type=template&id=3559c152&ts=true"
import script from "./mode.vue?vue&type=script&lang=ts"
export * from "./mode.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__